module.exports = __webpack_public_path__ + "img/logo_small.c5ba2af.png";